/*
 * @Author: 何泽颖 hezeying@autowise.ai
 * @Date: 2024-05-03 02:47:44
 * @LastEditors: 何泽颖 hezeying@autowise.ai
 * @LastEditTime: 2024-05-03 19:05:15
 * @FilePath: /mbti-web/app/components/WorkItemList/index.jsx
 * @Description:作品内人物列表
 */
'use client';

import { ItemListT, Pagination, CharacterSelect } from '@/components';
import { PAGESIZE } from '@/config';
import useRouter from '@/hooks/useRouter';
import { getList as getListAsync } from '@/service';
import { useEffect, useState } from 'react';
import withTheme from '@/theme';
import styles from './index.module.scss';

function WorkItemList(props) {
  const { id } = props;

  const [character, setCharactert] = useState(null); // 当前选中的性格
  const [itemList, setItemList] = useState([]); // 人物列表
  const [itemListCurrent, setItemListCurrent] = useState(1); // 人物列表当前页
  const [itemListTotal, setItemListTotal] = useState(0); // 人物列表总数
  const [loading, setLoading] = useState(true);

  const router = useRouter();

  /**
   * 通过作品搜索人物
   * @param {*} params
   * @return {*}
   */
  const searcWorkItems = async (params) => {
    setItemListCurrent(params.page);
    const res = await getListAsync(params);
    setItemList(res?.data || []);
    setItemListTotal(res?.count || 0);
    setLoading(false);
  };

  useEffect(() => {
    if (id) {
      searcWorkItems({
        work_id: id,
        page: 1,
        limit: PAGESIZE,
        mbti: '',
      });
    }
  }, [id]);

  return (
    <section className={styles.workItemList}>
      <div className={styles.workItemList_select}>
        <CharacterSelect
          value={character}
          onChange={(value) => {
            setCharactert(value || null);
            searcWorkItems({
              work_id: id,
              page: 1,
              limit: PAGESIZE,
              mbti: value || '',
            });
          }}
        />
      </div>

      <ItemListT
        itemList={itemList}
        name={''}
        click={(id) => {
          router.push(`/pediat?id=${id}`);
        }}
        loading={loading}
      />

      <Pagination
        current={itemListCurrent}
        total={itemListTotal}
        pageSize={PAGESIZE}
        showSizeChanger={false}
        onChange={(page) => {
          searcWorkItems({
            work_id: id,
            page,
            limit: PAGESIZE,
            mbti: character || '',
          });
        }}
      />
    </section>
  );
}

const WorkItemListCom = (props) => {
  return withTheme(<WorkItemList {...props} />);
};

export default WorkItemListCom;
